<ng-container *ngIf="state$ | async as state">

    <h2 mat-dialog-title class="pv-dialog-title">
        <mat-icon class="material-symbols-outlined">add_box</mat-icon>
        <span class="pv-dialog-title-text">Add Report Component</span>
        <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content class="pv-dialog-body">
        <form id="report_component_form"
            [formGroup]="formGroup"
            (ngSubmit)="attempt()"
            autocomplete="off"
        >
            <div class="field-block">
                <label class="field-label">Page</label>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="page" required>
                        <mat-option *ngFor="let pageVal of pageRange" [value]="(pageVal - 1)">Page {{ pageVal }}</mat-option>
                    </mat-select>
                    <mat-error>Select a page to add the component to</mat-error>
                </mat-form-field>
            </div>

            <div class="two-col">
                <div class="field-block">
                    <label class="field-label">Height</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput type="number" formControlName="height" required>
                        <span matSuffix>#</span>
                        <mat-hint>Component height</mat-hint>
                        <mat-error>Enter a valid height [min 1, max {{_data.maxRows}}]</mat-error>
                    </mat-form-field>
                </div>

                <div class="field-block">
                    <label class="field-label">Width</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput type="number" formControlName="width" required>
                        <span matSuffix>#</span>
                        <mat-hint>Component width</mat-hint>
                        <mat-error>Enter a valid width [min 1, max {{_data.maxColumns}}]</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="pv-dialog-footer">
        <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
        <button type="button" mat-flat-button color="primary" (click)="attempt()">
            <mat-icon>check</mat-icon>
            Apply
        </button>
    </mat-dialog-actions>

</ng-container>
